// "Foto en vivo": cuándo se sacó la última foto y cómo decirlo en hora argentina ("hoy 14:32").
const AR_MS = 3 * 3600e3; // Argentina: UTC-3 todo el año

/**
 * Momento (ms epoch) de la última foto. webback devuelve `date` en hora de la cámara sin zona
 * ("2026-10-15T17:50:00" = hora argentina); si trae zona (Z / ±hh:mm) se respeta. Si no hay fecha,
 * sale del nombre del archivo en S3 (…_20261015175005.jpg, también hora de la cámara).
 */
export function momentoDeFoto({ date, url, ms } = {}) {
  if (Number.isFinite(ms)) return ms;
  if (date) {
    const s = String(date).trim();
    if (/[zZ]$|[+-]\d{2}:?\d{2}$/.test(s)) { const t = Date.parse(s); if (Number.isFinite(t)) return t; }
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?/);
    if (m) return Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0)) + AR_MS;
  }
  if (url) {
    let nombre = '';
    try { nombre = decodeURIComponent(new URL(url).pathname.split('/').pop() || ''); } catch (e) { nombre = String(url); }
    const m = nombre.match(/(20\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(?!\d)/);
    if (m) return Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]) + AR_MS;
  }
  return null;
}

const DIAS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
const ar = (ms) => new Date(ms - AR_MS); // leer con getUTC* = hora argentina
const hhmm = (d) => `${String(d.getUTCHours()).padStart(2, '0')}:${String(d.getUTCMinutes()).padStart(2, '0')}`;
const dia = (d) => d.toISOString().slice(0, 10);

/** "hoy 14:32", "ayer 18:05", "lun 2/11 14:32" o "2/11/2025 14:32" (hora argentina). */
export function textoMomento(ms, ahora = Date.now()) {
  if (!Number.isFinite(ms)) return '';
  const f = ar(ms), h = ar(ahora);
  const ayer = ar(ahora - 864e5);
  if (dia(f) === dia(h)) return `hoy ${hhmm(f)}`;
  if (dia(f) === dia(ayer)) return `ayer ${hhmm(f)}`;
  const dm = `${f.getUTCDate()}/${f.getUTCMonth() + 1}`;
  if (ahora - ms < 6 * 864e5) return `${DIAS[f.getUTCDay()]} ${dm} ${hhmm(f)}`;
  return `${dm}/${f.getUTCFullYear()} ${hhmm(f)}`;
}

/** "hace 5 min", "hace 2 h", "hace 3 días" (o '' si es del futuro / no hay dato). */
export function hace(ms, ahora = Date.now()) {
  if (!Number.isFinite(ms)) return '';
  const min = Math.round((ahora - ms) / 60000);
  if (min < -5) return '';
  if (min < 1) return 'recién';
  if (min < 60) return `hace ${min} min`;
  const h = Math.round(min / 60);
  if (h < 24) return `hace ${h} h`;
  const d = Math.round(h / 24);
  return `hace ${d} ${d === 1 ? 'día' : 'días'}`;
}

export const REFRESCO_MS = 60_000;
